module.exports = __webpack_public_path__ + "img/seguros_la_agricola.d43b0366.png";